import React from "react";
import ContentLoader from "react-content-loader";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: "0 20px",
  },
}));

const ShimmerUserTable = () => {
  const classes = useStyles();
  const rows = 10; // number of shimmer rows

  return (
    <div className={classes.wrapper}>
      {[...Array(rows)].map((_, index) => (
        <ContentLoader
          key={index}
          speed={2}
          height={40}
          viewBox="0 0 1000 40"
          backgroundColor="#eaeaea"
          foregroundColor="#dddddd"
          style={{ marginBottom: "10px", borderRadius: "4px" }}
        >
          <rect x="10" y="10" rx="4" ry="4" width="180" height="15" />
          <rect x="210" y="10" rx="4" ry="4" width="150" height="15" />
          <rect x="390" y="10" rx="4" ry="4" width="120" height="15" />
          <rect x="550" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="780" y="10" rx="4" ry="4" width="40" height="15" />
        </ContentLoader>
      ))}
    </div>
  );
};

export default ShimmerUserTable;
